<template>
  <el-form
    :model="form"
    ref="form">
    <el-form-item
      :label="L10n('division')"
      prop="title"
      :rules="getValidationRule('required')"
      class="material-style">
      <el-input
        ref="firstField"
        :value="form.title"
        @input="form.title = valueTrimLeft($event)"
        @change="updateModelItem('title', { required: true })"/>
    </el-form-item>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'FormDivisions',
  mixins: [Form]
}
</script>
